module.exports = __webpack_public_path__ + "assets/img/yl_w_d_i_10.f419a9f9.jpg";